import * as React from 'react';

import { cn } from '@/lib/utils';

type CardProps = React.ComponentPropsWithoutRef<'div'> & {
  /** Adds an interactive hover treatment. */
  interactive?: boolean;
};

/** White surface card. The base unit for feature/bento grids. */
export function Card({ className, interactive, ...props }: CardProps) {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-2xl border border-hairline bg-white shadow-soft-sm',
        interactive &&
          'transition duration-300 hover:-translate-y-0.5 hover:border-ink-200 hover:shadow-lift',
        className
      )}
      {...props}
    />
  );
}
